import * as React from "react"
import Svg, { Circle } from "react-native-svg"

function SvgEllipse(props) {
    return (
        <Svg width={100} height={101} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Circle cx={71.5} cy={50.5} r={71.5} fill={props.fill} />
        </Svg>
    )
}

export default SvgEllipse
